import { render } from "./PhotoSuggestionsSidebarTab.vue?vue&type=template&id=c6298f9e&scoped=true"
import script from "./PhotoSuggestionsSidebarTab.vue?vue&type=script&lang=js"
export * from "./PhotoSuggestionsSidebarTab.vue?vue&type=script&lang=js"

import "./PhotoSuggestionsSidebarTab.vue?vue&type=style&index=0&id=c6298f9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6298f9e"]])

export default __exports__